import { getCustomerName } from 'client/actions/helpers/customerName'
import { Immutable } from 'client/Other/Immutable'

import { UNKNOWN_VALUE } from '../../Global/EInvoicingData'
import { DraftInterface } from '../../Interfaces/Draft/DraftInterface'
import { ModelInterface } from '../../Interfaces/Settings/ModelInterface'
import { SchemaInterface, SettingsInterface } from '../../Interfaces/Settings/SettingsInterface'

export function _isFieldVisible(fieldName: string, model: ModelInterface, schema: SchemaInterface): boolean {
  let visible = true
  const modelField = model.fields.filter((f) => {
    return f.name == fieldName
  })[0]
  const schemaField = schema.fields.filter((f) => {
    return f.name == fieldName
  })[0]
  if ((!modelField && !schemaField) || (modelField && !modelField.visible) || (schemaField && schemaField.hidden)) {
    visible = false
  }
  return visible
}

export function isFieldVisible(fieldName: string, settings: SettingsInterface, modelName: string) {
  const model = settings.models.filter((m) => {
    return m.type == modelName
  })[0]
  const schema = settings.schemas[modelName]
  if (!model || !schema) {
    return false
  }
  return _isFieldVisible(fieldName, model, schema)
}

export function getFieldDefaultValue(
  fieldName: string,
  settings: SettingsInterface,
  modelName: string,
): string | number {
  const model = settings.models.find((m) => m.type == modelName)
  if (!model) {
    return ''
  }
  const field = model.fields.find((f) => f.name === fieldName)
  return field ? field.default : ''
}

export function discardExtraTotals(draft: DraftInterface): DraftInterface {
  const document = Immutable.copy(draft)
  if (document.summary) {
    delete document.summary.foreignGrossTotal
    delete document.summary.foreignTaxTotal
    delete document.summary.foreignNetTotal
    delete document.summary.foreignWorkTotal
    delete document.summary.foreignReductionTotal

    delete document.summary.localGrossTotal
    delete document.summary.localTaxTotal
    delete document.summary.localNetTotal
    delete document.summary.localWorkTotal
    delete document.summary.localReductionTotal
  }
  return document
}

export function handleFieldsBeforeSave(draft: DraftInterface, settings?: SettingsInterface): DraftInterface {
  delete draft.invoiceId
  delete draft.editInvoice
  delete draft.preview
  delete draft.invalidFields
  delete draft.legacyInvoiceId
  if (draft.summary) {
    draft = discardExtraTotals(draft)
  }
  delete draft.fields.sender
  delete draft.fields.customer
  delete draft.isDirty

  if (draft.fields.exchangeRate && !draft.fields.exchangeRate.value) {
    delete draft.fields.exchangeRate
  }

  if (draft.fields.discountEnabled.value && draft.fields.discountLocation.value === 'perLine') {
    if (draft.fields.columns.value.indexOf('discount') < 0) {
      draft.fields.columns.value.push('discount')
    }
  } else if (draft.fields.columns.value.indexOf('discount') >= 0) {
    draft.fields.columns.value = draft.fields.columns.value.filter((c) => {
      return c !== 'discount'
    })
  }
  if (draft.fields.columns.value.indexOf('description') < 0) {
    draft.fields.columns.value.unshift('description')
  }
  if (draft.fields.columns.value.indexOf('productType') < 0) {
    draft.fields.columns.value.splice(draft.fields.columns.value.indexOf('description') + 1, 0, 'productType')
  }
  if (draft.fields.discountEnabled.value && draft.fields.discountLocation.value === 'perLine') {
    if (draft.fields.columns.value.indexOf('discount') < 0) {
      draft.fields.columns.value.push('discount')
    }
  } else if (draft.fields.columns.value.indexOf('discount') >= 0) {
    draft.fields.columns.value = draft.fields.columns.value.filter((c) => {
      return c !== 'discount'
    })
  }
  if (draft.fields.columns.value.indexOf('description') < 0) {
    draft.fields.columns.value.unshift('description')
  }
  if (draft.receiver.eInvoiceAddress && !draft.receiver.eInvoiceAddress.scheme) {
    delete draft.receiver.eInvoiceAddress
  } else if (draft.receiver.eInvoiceAddress) {
    if (draft.receiver.eInvoiceAddress.networkOperatorId === UNKNOWN_VALUE) {
      draft.receiver.eInvoiceAddress.networkOperatorId = null
    }
    if (draft.receiver.eInvoiceAddress.networkType === UNKNOWN_VALUE) {
      draft.receiver.eInvoiceAddress.networkType = null
    }
  }
  delete draft.receiver.ovt
  if (!draft.receiver.companyName) {
    draft.receiver.companyName = ''
  }
  getCustomerName(draft)
  if (!draft.receiver.businessId) {
    draft.receiver.businessId = ''
  }

  draft.fields.columns.value = draft.fields.columns.value.map((v) => (v == 'total' ? 'grossTotal' : v))

  delete draft.receiver.name
  delete draft.receiver.labourCostXHour

  return draft
}
